import React, { FC, memo, useCallback } from 'react';
import { useAppDispatch, useAppSelector } from 'app/config/storeConfig/hooks';
import { Drawer } from 'shared/ui/Drawer';
import { getRentOptionFormState } from '../model/selectors/getRentOptionFormState';
import { rentOptionFormDrawerActions } from '../model/slice/rentOptionFormDrawerSlice';
import { RentOptionForm } from './RentOptionForm';

export const RentOptionFormDrawer: FC = memo(() => {
  const dispatch = useAppDispatch();

  const rentOptionFormState = useAppSelector(getRentOptionFormState);

  const closeRentOptionFormDrawer = useCallback((): void => {
    dispatch(rentOptionFormDrawerActions.setOpenRentOptionForm({ mode: null, rentOption: null }));
  }, [dispatch]);

  return (
    <Drawer width={550} open={Boolean(rentOptionFormState.mode)} onClose={closeRentOptionFormDrawer}>
      <RentOptionForm rentOption={rentOptionFormState.rentOption} mode={rentOptionFormState.mode} handleClose={closeRentOptionFormDrawer} />
    </Drawer>
  );
});
